import { gsap } from 'gsap';
import { Transition } from '../Transition';
import '../types';

export class Spritesheet extends Transition {
  /**
   * @constructor
   * @class Spritesheet
   * @classdesc Controls all Spritesheet transitions
   * @param {options} options
   */
  constructor(options) {
    super(options);
  }

  /**
   * Method for the animation "in"
   * @returns {Promise}
   */
  in() {
    const duration = this._getOptionValue('duration');
    const container = this.createTransitionContainer();
    const rect = document.createElement('div');
    const tl = new gsap.timeline();

    tl.set(rect, {
      attr: {
        class: 'wb-transition-spritesheet wb-transition-spritesheet--in',
      },
      animationDuration: duration,
    });

    container.appendChild(rect);

    return new Promise((resolve) =>
      setTimeout(() => {
        document.dispatchEvent(new Event('barbaAnimInEnd'));
        resolve();
      }, duration * 1000)
    );
  }

  /**
   * Method for the animation "out"
   * @returns {Promise}
   */
  out() {
    const duration = this._getOptionValue('duration');
    const container = this.getTransitionContainer();
    const rect = document.querySelector('.wb-transition-spritesheet');
    const newRect = document.createElement('div');
    const tl = new gsap.timeline();

    tl.set(newRect, {
      attr: {
        class: 'wb-transition-spritesheet wb-transition-spritesheet--out',
      },
      animationDuration: duration,
      onComplete: () => {
        rect.remove();
      },
    });

    container.appendChild(newRect);

    document.dispatchEvent(new Event('barbaAnimOutStart'));

    return new Promise((resolve) =>
      setTimeout(() => {
        container.remove();
        resolve();
      }, duration * 1000)
    );
  }
}
